import BadgerAccordion from 'badger-accordion';

export default class CountryNavLanguageAccordion {
  constructor(
    elementSelector = '.js-swa-country-nav-accordion-language',
    headerClass = '.js-swa-country-language-button',
    panelClass = '.js-swa-country-nav-accordion-language-panel',
    panelInnerClass = '.js-swa-country-nav-accordion-language-panel-inner',
    activeClass = 'swa-country-nav-accordion-language-is-active',
    hiddenClass = 'swa-country-nav-accordion-language-is-hidden',
    initializedClass = 'swa-country-nav-accordion-language-initialized',
    headerDataAttr = 'data-swa-country-nav-accordion-language-id'
  ) {
    this.elementSelector = elementSelector;
    this.headerClass = headerClass;
    this.panelClass = panelClass;
    this.panelInnerClass = panelInnerClass;
    this.activeClass = activeClass;
    this.hiddenClass = hiddenClass;
    this.initializedClass = initializedClass;
    this.headerDataAttr = headerDataAttr;
  }

  init() {

    const accordions = document.querySelectorAll(this.elementSelector);

    if (!accordions) {
      return;
    }

    let accordionLanguagePanel = [];

    // Create a new instance of the accordion
    Array.from(accordions).forEach((accordion) => {
       accordionLanguagePanel.push(
         new BadgerAccordion(accordion, {
          headerClass: this.headerClass,
          panelClass: this.panelClass,
          panelInnerClass: this.panelInnerClass,
          activeClass: this.activeClass,
          hiddenClass: this.hiddenClass,
          initializedClass: this.initializedClass,
          headerDataAttr: this.headerDataAttr
        })
      );
    });

    const accordionHeaderButtonElements = document.querySelectorAll(
      '.swa-country-nav-accordion-language__header'
    );

    //Close a given panel using its headerIndex
    accordionHeaderButtonElements.forEach(button => {
      button.addEventListener('click', function(event) {
        let currentTarget = event.currentTarget;
        const headerAcc = document.querySelectorAll('.js-swa-country-language-button');

        headerAcc.forEach((elem, headerIndex) => {
          if (elem === currentTarget.querySelector('.js-swa-country-language-button')) {
            return;
          } else
             if (elem !== currentTarget.querySelector('.js-swa-country-language-button') &&
             elem.classList.contains('swa-country-nav-accordion-language-is-active')) {
               accordionLanguagePanel[headerIndex].close(0);
          }
        });
      });
    });

  }
}
